export default __webpack_public_path__ + "static/media/banner2.59a0c422.jpg";